import React from 'react';
import { Grid } from '@material-ui/core';
import { Message } from 'models/Message';
import { Colors, Paper } from 'library';
import { Thread } from './Thread';
import { ThreadHeader } from './ThreadHeader/ThreadHeader';
import { IMessageForm } from './models';
import { getMaxHeight } from './messageUtils';
import { useWidth } from 'reusableComponents/useWidth';

export default function WebMessageForm({
    providerIdObject,
    messageToSend,
    contactThread,
    providerName,
    messagesEndRef,
    bottomOfThread,
    user,
    MessageInput,
    providerImage,
    role,
}: IMessageForm) {
    const screenSize = useWidth();

    return (
        <Paper padding={0} key="web-message">
            <Grid xs={12}>
                <ThreadHeader providerIdObject={providerIdObject} providerName={providerName ?? ''} role={role} />
                <Grid xs={12}>
                    <Grid
                        item
                        xs={12}
                        style={{
                            maxHeight: getMaxHeight(false, screenSize),
                            overflowY: 'scroll',
                            padding: 30,
                            paddingBottom: messageToSend.trim().length === 0 ? 0 : 30,
                        }}
                    >
                        {contactThread &&
                            contactThread.map((message: Message, i: number) => (
                                <div key={i}>
                                    <Thread message={message} user={user} providerImage={providerImage} />
                                </div>
                            ))}
                        <Grid ref={bottomOfThread} />
                    </Grid>

                    {providerIdObject.user.id === 240 ? (
                        <>
                            <hr
                                style={{
                                    color: Colors.darkGrey,
                                    width: '100%',
                                    padding: 0,
                                }}
                            />
                            <Grid item xs={12} style={{ padding: 30, paddingTop: 0 }}>
                                {MessageInput}
                            </Grid>
                        </>
                    ) : null}
                </Grid>
            </Grid>
            <Grid ref={messagesEndRef} />
        </Paper>
    );
}
